import { createFileRoute } from '@tanstack/react-router'
import { Home, Settings } from 'lucide-react'
import { useEffect, useMemo } from 'react'
import { ActivityTab } from '@/features/events/components/ActivityTab'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/shared/components/ui/breadcrumb'
import { useBreadcrumbs } from '@/shared/hooks/useBreadcrumbs'

export const Route = createFileRoute('/_auth/settings/activity')({
  component: () => <ActivityPage />,
})

function ActivityPage() {
  const { setBreadcrumbs } = useBreadcrumbs()

  const breadcrumbsContent = useMemo(
    () => (
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink to='/dashboard' className='flex items-center gap-1'>
              <Home className='w-4 h-4' />
              Dashboard
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <span className='flex items-center gap-1 text-muted-foreground'>
              <Settings className='w-4 h-4' />
              Settings
            </span>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Activity</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    ),
    []
  )

  useEffect(() => {
    setBreadcrumbs(breadcrumbsContent)
  }, [setBreadcrumbs, breadcrumbsContent])

  return (
    <div className='container mx-auto py-6'>
      <div className='space-y-6'>
        {/* Page Header */}
        <div className='space-y-2'>
          <h1 className='text-2xl font-bold'>Activity</h1>
          <p className='text-muted-foreground'>
            Track user actions and system changes across your platform
          </p>
        </div>

        <ActivityTab />
      </div>
    </div>
  )
}
